export interface UseAdvertisementProps {
  onReward?: () => void;
  onError?: (error: Error) => void;
  onSkip?: () => void;
}

export enum CustomErrorCode {
  GENERAL_ERROR = 'GENERAL_ERROR',
  NO_AVAILABLE_ADS = 'NO_AVAILABLE_ADS',
}

export class ErrorWithCode extends Error {
  public code?: string;
  constructor(message: string, code?: string) {
    super(message);
    if (code) this.code = code;
  }
}
